module.exports = __webpack_public_path__ + "fonts/CrimsonText-Regular.ef7d3c04.woff";